"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EthersAdapter = void 0;
const ethers_1 = require("ethers");
class EthersAdapter {
    rpcProvider(rpc) {
        return new ethers_1.ethers.JsonRpcProvider(rpc);
    }
    contract(address, abi, provider) {
        // type hack to support ethers v5
        return new ethers_1.ethers.Contract(address, abi, provider);
    }
    interface(abi) {
        return new ethers_1.ethers.Interface(abi);
    }
    serializeTransaction(tx) {
        return ethers_1.ethers.Transaction.from(tx).unsignedSerialized;
    }
}
exports.EthersAdapter = EthersAdapter;
//# sourceMappingURL=EthersAdapter.js.map